import { useEffect, useState } from 'react';
import { EmailConfigDTO, LexOfficeS } from '../LexOfficeS';

// eslint-disable-next-line import/prefer-default-export
export const useEmailAccountingConfig = () => {
  const [loading, setLoading] = useState(false);
  const [config, setConfig] = useState<EmailConfigDTO | null>(null);
  const { email } = config ?? { email: null };

  useEffect(() => {
    setLoading(true);
    LexOfficeS.getEmailConfig()
      .then(setConfig)
      .finally(() => setLoading(false));
  }, []);

  const update = async (val: string) => {
    const resJSON = await LexOfficeS.patchEmailConfig({ email: val });
    if (resJSON) {
      return true;
    }
    return false;
  };

  return { loading, config, email, update };
};
